import { render, staticRenderFns } from "./HistorialVentas.vue?vue&type=template&id=9c09d7d8&"
import script from "./HistorialVentas.vue?vue&type=script&lang=js&"
export * from "./HistorialVentas.vue?vue&type=script&lang=js&"
import style0 from "./HistorialVentas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports